const onSelect = (handler) => {
  return (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handler(event);
    }
  };
};
export default onSelect;
